<template>
    <div :class="classes">
        <div v-if="loader" :class="theme.loader">
            <v-spinner />
        </div>

        <div :class="theme.cardHeader" @click="handleToggleOpen">
            <slot name="header"></slot>
            <v-icon-button v-if="collapse" :class="theme.cardCollapseButton">
                expand_more
            </v-icon-button>
        </div>

        <slot v-if="!collapse"></slot>
        <v-animation-height v-else :height="contentHeight">
            <slot :open="isOpen"></slot>
        </v-animation-height>
    </div>
</template>
<script>
    import { vSpinner } from '../Spinner';
    import { vIconButton } from '../Button';
    import { vAnimationHeight } from '../AnimationHeight';
    import theme from './card.scss';

    export default {
        name: 'card',
        components: {
            vAnimationHeight,
            vIconButton,
            vSpinner,
        },
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            collapse: {
                type: Boolean,
                default: false,
            },
            stretch: {
                type: Boolean,
                default: false,
            },
            loader: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                isOpen: !this.collapse,
            }
        },
        computed: {
            classes() {
                return {
                    [theme.card]: true,
                    [theme.isStretch]: this.stretch,
                    [theme.isCollapse]: this.collapse,
                    [theme.isOpen]: this.collapse && this.isOpen,
                }
            },
            contentHeight() {
                switch(true) {
                    case this.stretch === false && this.collapse === false:
                    case this.stretch:
                        return 'auto';
                    default:
                        return this.isOpen ? 'auto' : 0;
                }
            },
        },
        methods: {
            handleToggleOpen() {
                if (this.collapse) {
                    this.isOpen = !this.isOpen;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Card.vue?7cd7d6a3